import React, { useContext } from "react";
import { Collapse, Badge, Skeleton } from "antd";
import { FaLink } from "react-icons/fa";
import LinkChart from "./Graphs/LinkChart";
import { RootContext } from "../../RootContextProvider";
import { MdEmail } from "react-icons/md";
import { IoIosImages } from "react-icons/io";

const { Panel } = Collapse;

const LinksSection = ({ linkStats, loading, dates }) => {
  const { links } = useContext(RootContext);
  const renderHeader = (linkType, linkName, isActive, clicks) => {
    return (
      <div className="link-header">
        <div className="link-content-name">
          <div className="link-display-icon">
            {linkType === "regular" && <FaLink className="icon-link-stats" />}
            {linkType === "email" && <MdEmail className="icon-link-admin" />}
            {linkType.startsWith("thumbnail") && (
              <IoIosImages className="icon-link-admin" />
            )}
          </div>
          {linkName}{" "}
        </div>
        <div className="link-status">
          Status :{" "}
          {isActive ? (
            <span>
              <Badge status="success" /> En ligne
            </span>
          ) : (
            <span>
              <Badge status="error" /> Hors ligne
            </span>
          )}
        </div>
        <div className="link-stat">
          <div className="link-clics">
            <div className="dot-clicks" />
            <div className="link-status">
              Clics: <b>{clicks}</b>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="links-stats">
      {loading ? <Skeleton active /> : ""}
      {!loading ? (
        <>
          <Collapse expandIconPosition="right">
            {/* eslint-disable-next-line */}
            {links.map((link) => {
              if (
                link.LinkType === "email" ||
                link.LinkType === "regular" ||
                link.LinkType.startsWith("thumbnail")
              ) {
                let linkIndex = linkStats.findIndex(
                  (linkStat) => linkStat.key === link.LinkID
                );
                return (
                  <Panel
                    header={renderHeader(
                      link.LinkType,
                      link.LinkTitle,
                      link.IsActive,
                      linkStats[linkIndex] ? linkStats[linkIndex].doc_count : 0
                    )}
                    key={link.LinkID}
                  >
                    <div className="link-url">
                      URL :
                      <a
                        href={link.LinkUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <em>{link.LinkUrl}</em>
                      </a>
                    </div>
                    <LinkChart
                      stats={
                        linkStats[linkIndex]
                          ? linkStats[linkIndex].stats_per_day.buckets
                          : []
                      }
                      dates={dates}
                    />
                  </Panel>
                );
              }
            })}
          </Collapse>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default LinksSection;
